/** Where players appeal a sanction or raise a complaint. Named in the rules, the terms and every ban notice. */
export const STEWARDS_EMAIL = 'support@mossforge.dev';

/** Who runs Wynchester: the data controller in the privacy notice and the other party in the terms. */
export const OPERATOR = 'Jon Moss';
